<template>
  <div v-if="program" class="f-h f-sb m-bx2">
    <div class="f-v m-t10 t-xl bold">
      {{ capitalize($i18n.t('shoutouts.reward', { count: 2 })) }} Program
      <p v-if="!canToggleRewards" class="t m-rx2 warning-yellow">
        Must have automated gift cards enabled or 1 or more {{ $i18n.t('shoutouts.reward', { count: 1 }) }}.
      </p>
    </div>
    <div class="f-ac">
      <p class="t m-rx2">Enable {{ $i18n.t('shoutouts.reward', { count: 2 }) }} program</p>
      <donut-input-toggle
        :model-value="program.state === 'active'"
        :is-disabled="state.rewardsProgram.loading || !canToggleRewards"
        update-action="rewardsProgram/updateRewardsProgram"
        :update-args="{ key: 'state', value: program.state === 'active' ? 'inactive' : 'active' }"
      />
    </div>
  </div>
</template>

<script setup>
import { computed, inject } from 'vue';
import { useStore } from 'vuex';
import { capitalize } from 'lodash';

const { state } = useStore();

const $i18n = inject('$i18n');

const program = computed(() => state.rewardsProgram.program);
const activeListings = computed(() => state.rewardsListings.listings.filter(listing => listing.id && listing.state === 'active'));

const canToggleRewards = computed(() => {
  if (program.value.state === 'active') {
    return true;
  }

  return activeListings.value.length >= 1;
});
</script>
